import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	apps: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.ecosystem-apps.apps',
		defaultMessage: 'Apps',
		description: 'Apps link item',
	},
	appFields: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.ecosystem-apps.app-fields',
		defaultMessage: 'App fields',
		description: 'App fields link item within apps sub-menu',
	},
	backItem: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.ecosystem-apps.back-item',
		defaultMessage: 'Back',
		description: 'Back menu item',
	},
});
